export default __webpack_public_path__ + "static/media/menu.ac077104.svg";